/* eslint-disable prettier/prettier */
import { createClient } from '@supabase/supabase-js'

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY

export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    autoRefreshToken: true,
    persistSession: true,
    detectSessionInUrl: true
  }
})

/**
 * Get public URL for a file in a specific bucket
 * @param {string} filePath
 * @param {string} bucket
 */
export const getPublicUrl = (filePath, bucket) => {
  const { data } = supabase.storage.from(bucket).getPublicUrl(filePath)
  return data.publicUrl
}

/**
 * Upload a file to a specific bucket and return public URL
 * @param {string} filePath  path INSIDE the bucket, no bucket name prefix
 * @param {File|Blob} file
 * @param {string} bucket
 */
export const uploadFile = async (filePath, file, bucket) => {
  const { error } = await supabase.storage.from(bucket).upload(filePath, file, { upsert: true })
  if (error) throw error
  return getPublicUrl(filePath, bucket)
}

export default supabase